import axios from "axios";

const instance = axios.create({
  baseURL: "https://phosphor-api.codebnb.me/"
});

export default instance;



// WEBPACK FOOTER //
// ./src/http/axios.js